import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, KeyRound, Mail, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e?.preventDefault();
    if (!email.trim()) { setError("Please enter your email."); return; }
    setError(""); setLoading(true);
    try {
      await api("/auth/forgot-password", { method: "POST", body: { email: email.trim() }, auth: false });
      setSent(true);
    } catch (err) {
      setError(err.message || "Could not send reset link");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-md mx-auto px-6 py-10">
        <button data-testid="back-btn" onClick={() => navigate(-1)} className="w-10 h-10 grid place-items-center -ml-2 hover:bg-[#F5F5F5] rounded-lg">
          <ArrowLeft size={20} />
        </button>
        <div className="mt-6"><KeyRound size={36} color="#D62828" /></div>
        <h1 className="font-display text-3xl font-black mt-4">Forgot password?</h1>
        <p className="mt-2 text-[15px]" style={{ color: "#5A5A5A" }}>Enter your email and we'll send you a link to reset it.</p>

        {sent ? (
          <div data-testid="forgot-success" className="mt-8 p-6 rounded-2xl text-center status-placed">
            <Mail size={28} className="mx-auto" />
            <h3 className="font-display text-xl font-black mt-2">Check your inbox</h3>
            <p className="text-sm mt-2" style={{ color: "#5A5A5A" }}>If an account exists for {email.trim()}, we just sent a reset link. The link expires in 1 hour.</p>
            <button data-testid="back-to-login-btn" onClick={() => navigate("/login")} className="btn-primary w-full mt-5 !py-3.5">Back to Sign In</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="label-up">Email</label>
              <input data-testid="forgot-email-input" type="email" className="input-field" placeholder="you@agency.com" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            {error && <div data-testid="forgot-error" className="text-sm font-bold" style={{ color: "#C62828" }}>{error}</div>}
            <button data-testid="forgot-submit-btn" disabled={loading} className="btn-primary w-full !py-3.5">
              {loading ? <Loader2 className="animate-spin" size={18} /> : "Send Reset Link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
